import { Badge } from "../components/ui/badge";

const LABELS = {
    ny: "Ny",
    afventer_kunde: "Afventer kunde",
    afventer_svar: "Afventer svar",
    selvbook_sendt: "Selvbook sendt",
    reklamation_booket: "Reklamation booket",
    sendt_til_leverandoer: "Sendt til leverandør",
    sendt_til_medarbejder: "Sendt til medarbejder",
    produktion_godkendt: "Produktion godkendt",
    godkendt: "Godkendt",
    afvist: "Afvist",
    lukket: "Lukket",
};

export default function StatusBadge({ status, className = "" }) {
    const label = LABELS[status] || status;
    return (
        <Badge
            variant="outline"
            className={`status-${status} border-0 rounded-full px-3 py-1 text-xs font-medium ${className}`}
            data-testid="complaint-status-badge"
        >
            {label}
        </Badge>
    );
}

export { LABELS as STATUS_LABELS };
